import { Icon } from '@chakra-ui/react';

export const MarketplaceIconSvg = ({
  size = 5,
  theme = 'light',
}: {
  size?: number;
  theme?: 'light' | 'dark';
}): JSX.Element => {
  const color = theme === 'light' ? 'white' : 'black';

  return (
    <Icon
      fill={color}
      height={size}
      viewBox="0 0 26 26"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.85814 22.3131H0.929069C0.415747 22.3131 0 21.9006 0 21.3913C0 20.882 0.415747 20.4696 0.929069 20.4696H15.7942C16.3075 20.4696 16.7232 20.882 16.7232 21.3913C16.7232 21.9006 16.3075 22.3131 15.7942 22.3131H14.8651V24.3409C14.8651 24.69 14.7316 25.0322 14.447 25.3225C14.087 25.6901 13.3798 26 12.5425 26H4.18084C3.34352 26 2.63627 25.6901 2.27626 25.3225C1.99174 25.0322 1.8582 24.69 1.8582 24.3409L1.85814 22.3131ZM19.586 9.14828L13.6735 15.0141C13.6886 15.1212 13.6967 15.2307 13.6967 15.3401C13.6967 15.9508 13.4517 16.5373 13.0162 16.9693L12.3589 17.6214C11.9234 18.0535 11.3334 18.2966 10.7179 18.2966C10.1013 18.2966 9.5113 18.0535 9.07465 17.6214L5.13302 13.7109C4.69753 13.2788 4.45246 12.6924 4.45246 12.0817C4.45246 11.4699 4.69751 10.8835 5.13302 10.4514L5.79032 9.80046C6.22581 9.36841 6.81694 9.12528 7.43244 9.12528C7.54277 9.12528 7.6531 9.13334 7.76111 9.14832L13.6736 3.28253C13.6585 3.17538 13.6503 3.06592 13.6503 2.95646C13.6503 2.34581 13.8954 1.75935 14.3309 1.3273L14.9882 0.675184C15.4237 0.243132 16.0136 0 16.6291 0C17.2458 0 17.8358 0.243109 18.2724 0.675184L22.2141 4.58571C22.6495 5.01776 22.8946 5.60422 22.8946 6.21487C22.8946 6.82666 22.6496 7.41313 22.2141 7.84518L21.5568 8.49614C21.1213 8.92938 20.5301 9.17133 19.9146 9.17133C19.8043 9.17133 19.694 9.16326 19.586 9.14828ZM20.047 11.5621L25.1743 16.6477C26.2752 17.74 26.2752 19.512 25.1743 20.6043L25.172 20.6066C24.0977 21.6723 22.3557 21.6723 21.2815 20.6066L16.1066 15.4726L20.047 11.5621Z"
      />
    </Icon>
  );
};
